import { render, staticRenderFns } from "./ChartLivraison.vue?vue&type=template&id=816d3df2&scoped=true&"
import script from "./ChartLivraison.vue?vue&type=script&lang=js&"
export * from "./ChartLivraison.vue?vue&type=script&lang=js&"
import style0 from "./ChartLivraison.vue?vue&type=style&index=0&id=816d3df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816d3df2",
  null
  
)

export default component.exports